import { chef } from 'cookery';
import fieldBaseTpl from '../base';
import './styles';

const fieldTextareaTpl = (initData = {}) => {
    return fieldBaseTpl(initData);
}

export { fieldTextareaTpl }